import { defineStore } from 'pinia'
import { ref } from 'vue'

// change for all other data too: 1 for all array + one for manipulation arr
export const useFilterStore = defineStore('filters', () => {
  const preSelectedWorkField = window.tx_jobs.job_offer_list.workField
  const allLocations = ref([])
  const allWorkFields = ref([])
  const allJobCategories = ref([])
  const allEmployments = ref([])
  const allCareerLevels = ref([])
  const selectedLocations = ref([])
  const selectedWorkFields = ref([])
  const selectedCategories = ref([])
  const selectedEmployments = ref([])
  const selectedCareerLevels = ref([])
  const searchQueryInput = ref("")

  function setSearchQueryInput(inputString) {
    searchQueryInput.value = inputString
  }

  function getLocationTitleWithUid(uid) {
    const match = allLocations.value.filter(el => el.uid === uid)
    if (match.length > 0) {
      return match[0].title
    }
    return ''
  }
  function isLocationSelected(location) {
    return selectedLocations.value.filter(el => el.uid === location.uid).length
  }
  function handleSelectedLocations(location) {
    if (isLocationSelected(location)) {
      const index = selectedLocations.value.findIndex(el => el.uid === location.uid)
      selectedLocations.value.splice(index, 1)
    } else {
      selectedLocations.value.push(location)
    }
  }

  function getSelectedLocationUids() {
    let locationPidArr = []
    selectedLocations.value.forEach(element =>
    {
      if (element.uid) {
        locationPidArr.push(element.uid)
      }
    })
    return locationPidArr
  }

  function getWorkFieldTitleWithUid(uid) {
    const match = allWorkFields.value.filter(el => el.uid === uid)
    if (match.length > 0) {
      return match[0].title
    }
    return ''
  }

  function isWorkFieldSelected(workField) {
    return selectedWorkFields.value.filter(el => el.uid === workField.uid).length
  }
  function handleSelectedWorkFields(workField) {
    if (isWorkFieldSelected(workField)) {
      const index = selectedWorkFields.value.findIndex(el => el.uid === workField.uid)
      selectedWorkFields.value.splice(index, 1)
    } else {
      selectedWorkFields.value.push(workField)
    }
  }

  function getSelectedWorkFieldUids() {
    let workFieldPidArr = []
    selectedWorkFields.value.forEach(element =>
    {
      if (element.uid) {
        workFieldPidArr.push(element.uid)
      }
    })
    return workFieldPidArr
  }

  function getCategoryTitleWithUid(uid) {
    const match = allJobCategories.value.filter(el => el.uid === uid)
    if (match.length > 0) {
      return match[0].title
    }
    return ''
  }

  function isCategorySelected(category) {
    return selectedCategories.value.filter(el => el.uid === category.uid).length
  }
  function handleSelectedCategories(category) {
    if (isCategorySelected(category)) {
      const index = selectedCategories.value.findIndex(el => el.uid === category.uid)
      selectedCategories.value.splice(index, 1)
    } else {
      selectedCategories.value.push(category)
    }
  }

  function getSelectedCategoryUids() {
    let categoryPidArr = []
    selectedCategories.value.forEach(element =>
    {
      if (element.uid) {
        categoryPidArr.push(element.uid)
      }
    })
    return categoryPidArr
  }

  function getEmploymentTitleWithUid(uid) {
    const match = allEmployments.value.filter(el => el.uid === uid)
    if (match.length > 0) {
      return match[0].title
    }
    return ''
  }

  function isEmploymentSelected(employment) {
    return selectedEmployments.value.filter(el => el.uid === employment.uid).length
  }
  function handleSelectedEmployments(employment) {
    if (isEmploymentSelected(employment)) {
      const index = selectedEmployments.value.findIndex(el => el.uid === employment.uid)
      selectedEmployments.value.splice(index, 1)
    } else {
      selectedEmployments.value.push(employment)
    }
  }

  function getSelectedEmploymentUids() {
    let employmentPidArr = []
    selectedEmployments.value.forEach(element =>
    {
      if (element.uid) {
        employmentPidArr.push(element.uid)
      }
    })
    return employmentPidArr
  }

  function getCareerLevelTitleWithUid(uid) {
    const match = allCareerLevels.value.filter(el => el.uid === uid)
    if (match.length > 0) {
      return match[0].title
    }
    return ''
  }

  function isCareerLevelSelected(careerLevel) {
    return selectedCareerLevels.value.filter(el => el.uid === careerLevel.uid).length
  }
  function handleSelectedCareerLevels(careerLevel) {
    if (isCareerLevelSelected(careerLevel)) {
      const index = selectedCareerLevels.value.findIndex(el => el.uid === careerLevel.uid)
      selectedCareerLevels.value.splice(index, 1)
    } else {
      selectedCareerLevels.value.push(careerLevel)
    }
  }

  function getSelectedCareerLevelUids() {
    let careerLevelPidArr = []
    selectedCareerLevels.value.forEach(element =>
    {
      if (element.uid) {
        careerLevelPidArr.push(element.uid)
      }
    })
    return careerLevelPidArr
  }

  function getSearchQueryInput() {
    return '%' + searchQueryInput.value + '%'
  }

  return {
    preSelectedWorkField,
    allLocations,
    allWorkFields,
    allJobCategories,
    allEmployments,
    allCareerLevels,
    selectedLocations,
    selectedWorkFields,
    selectedCategories,
    selectedEmployments,
    selectedCareerLevels,
    searchQueryInput,
    setSearchQueryInput,
    getLocationTitleWithUid,
    isLocationSelected,
    handleSelectedLocations,
    getSelectedLocationUids,
    isWorkFieldSelected,
    getWorkFieldTitleWithUid,
    handleSelectedWorkFields,
    getSelectedWorkFieldUids,
    isCategorySelected,
    getCategoryTitleWithUid,
    handleSelectedCategories,
    getSelectedCategoryUids,
    isEmploymentSelected,
    getEmploymentTitleWithUid,
    handleSelectedEmployments,
    getSelectedEmploymentUids,
    getCareerLevelTitleWithUid,
    isCareerLevelSelected,
    handleSelectedCareerLevels,
    getSelectedCareerLevelUids,
    getSearchQueryInput
  }
})
